import clsx from "clsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
interface MenuDrawerDesktopProps {
  targetHeight: number;
  children: ReactNode;
}

const MenuDrawerDesktop = ({ targetHeight, children }: MenuDrawerDesktopProps) => {
  const borderClasses = clsx({
    "ring-[1px] ring-fog-20": targetHeight > 0,
  });

  const baseDrawerClasses =
    "absolute left-0 right-0 lg:top-navbar-lg top-navbar m-auto w-screen max-w-screen-xl overflow-hidden bg-fog-00 transition-all duration-300 ease-in-out xl:rounded-b-xl animate-fade";

  return (
    <div>
      {/* Serves as drop shadow, since overflow needs to be hidden in order to animate height properly */}
      <div
        role="presentation"
        className={twMerge("shadow-2xl", baseDrawerClasses, borderClasses)}
        style={{ height: targetHeight }}
      />
      <div className={twMerge("z-10", baseDrawerClasses)} style={{ height: targetHeight }}>
        {children}
      </div>
    </div>
  );
};

export { MenuDrawerDesktop };
